import LoginRequiredModal from 'components/Modal/LoginRequiredModal'
import { useBorderListContext } from 'contexts/BorderListContext'
import { useOrderInfo } from 'contexts/OrderInfoContext'
import ModalChooseOption from './ModalChooseOption'
import ProfileItem from 'components/ProfileItem'
import { useAuth } from 'contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import OrderInfoModal from './OrderInfoModal'
import BottomBar from 'components/BottomBar'
import TopBar from 'components/Topbar'
import Marger from 'components/Marger'
import Button from 'components/Button'
import useStore from 'hooks/useStore'
import { useState } from 'react'
import './index.scss'

type ModalData = {
  type: 'chooseOption'
  qr_id: string
  id: string
} | {
  type: 'login'
} | {
  type: ''
}

const Dashboard: React.FC = () => {
  const { isAuth, user } = useAuth()
  const [orderInfo, , setOrderInfo] = useOrderInfo()
  const { data, isLoading, reload } = useBorderListContext()
  const [modal, setModal] = useState<ModalData>({
    type: ''
  })

  const openStore = useStore()
  const navigate = useNavigate()
  const renderSkeletonItems = (count: number | undefined) => {
    if (!count) {
      return null
    }
    return Array.from({ length: count }, (_, index) => (
      <div key={index} className='skeleton-item'></div>
    ))
  }

  const profileAction = (item: board.Board, isMyBoards?: boolean) => {
    item.is_empty ?
      navigate(`/addprofile/${item.id}/update`)
      : isMyBoards
        ? setModal({ type: 'chooseOption', id: item.id, qr_id: item.qr_id })
        : navigate(`/${item.biography ? 'profile' : 'profilepin'}/${item.id}`)
  }

  const renderProfileItems = (items: board.Board[] | null, isGrouped: boolean, isMyBoards?: boolean, key = '1') => {
    if (isGrouped && items) {
      return (
        <div
          key={key}
          className="group">
          {items.map((item) => (
            <ProfileItem
              id={item.id}
              black={item.is_empty}
              key={item.id}
              name={item.name}
              img={item.img_thumbnail}
              need_biography={item.need_biography}
              notification={isMyBoards ? item.notificationsCount : -1}
              isPaid={isMyBoards ? item.is_paid : undefined}
              action={() => profileAction(item, isMyBoards)}
            />
          ))}
          <Marger />
        </div>
      )
    }
    return items && items.map((item) => (
      <ProfileItem
        id={item.id}
        black={item.is_empty}
        key={item.id}
        name={item.name}
        img={item.img_thumbnail}
        need_biography={item.need_biography}
        notification={isMyBoards ? item.notificationsCount : -1}
        isPaid={isMyBoards ? item.is_paid : undefined}
        action={() => profileAction(item, isMyBoards)}
      />
    ))
  }

  const renderMyBoards = () => {
    if (isLoading) {
      return (
        <div className='skeleton'>
          <div className='skeleton-title'></div>
          {renderSkeletonItems(user?.myProfilesAmount || 2)}
        </div>
      )
    }

    const myBoardsContent = data && Object.keys(data.myBoards).map((key) => {
      const boards = data.myBoards[key]
      const isGrouped = boards.length > 1
      return renderProfileItems(boards, isGrouped, true, key)
    })

    return (myBoardsContent && myBoardsContent?.length > 0 &&
      <div className="dashboard__myProfiles">

        <div className="dashboard__title">
          <h2>Zarządzane wirtualne profile</h2>
        </div>
        {myBoardsContent}
      </div>
    )
  }

  const renderSavedBoards = () => {
    if (isLoading) {
      return (
        <div className='skeleton'>
          <div className='skeleton-title'></div>
          {renderSkeletonItems(user?.savedProfilesAmount || 2)}
        </div>
      )
    }

    const thereAreSavedBoards = data?.savedBoards
      ? Object.keys(data.savedBoards).length > 0
      : false

    return (thereAreSavedBoards &&
      <div className="dashboard__myProfiles">
        <div className="dashboard__title">
          <h2>Zapisane wirtualne profile</h2>
        </div>
        {Object.entries(data!.savedBoards).map(([key, list]) => {
          const isGrouped = key !== '' && list.length > 1
          return renderProfileItems(list, isGrouped, false)
        })}
      </div>
    )
  }

  const renderObituaries = () => {
    if (isLoading) {
      return (
        <div className='skeleton'>
          <div className='skeleton-title'></div>
          {renderSkeletonItems(user?.savedProfilesAmount || 2)}
        </div>
      )
    }

    const thereAreObituaries = data?.obituaries
      ? Object.keys(data.obituaries).length > 0
      : false

    return thereAreObituaries && (
      <div className="dashboard__myProfiles">
        <div className="dashboard__title">
          <h2>Nekrologi</h2>
        </div>
        {Object.values(data!.obituaries).map((list) => {
          return list.map((item) => (
            <ProfileItem
              id={item.id}
              black={item.is_empty}
              key={item.id}
              name={item.name}
              img={item.img_thumbnail}
              notification={-1}
              isObituary
              action={() => {
                navigate(item.is_empty ? `/addobituary/${item.id}` : `/profilepin/${item.id}`)
              }}
            />
          ))
        })}
      </div>
    )
  }

  const areAllEmpty = data &&
    Array.isArray(data?.myBoards) && data.myBoards.length === 0 &&
    Array.isArray(data?.savedBoards) && data.savedBoards.length === 0 &&
    Array.isArray(data?.obituaries) && data.obituaries.length === 0

  return (
    <>
      {orderInfo && <OrderInfoModal
        onClose={(refresh) => {
          setOrderInfo(undefined)
          if (refresh === true) {
            reload()
          }
        }}
      />}
      {modal.type === 'chooseOption' && <ModalChooseOption
        id={modal.id}
        qr_id={modal.qr_id}
        onClose={() => {
          setModal({ type: '' })
        }}
      />}
      {modal.type === 'login' && <LoginRequiredModal
        customRedirect={{ pathname: '/addprofile', state: { view: 'qrScanner', nextPage: 'form' } }}
        onClose={() => {
          setModal({ type: '' })
        }}
      />}
      <div className='dashboard'>
        <TopBar isSticky={true} theme='dark' />
        {(!areAllEmpty && !isAuth) && <div className='dashboard__loginInfo'>
          <p>Chcesz zapisać profile?</p>
          <Button
            type='primary'
            text='Utwórz konto'
            action={() => {
              navigate('/signin')
            }}
          />
        </div>}

        {renderObituaries()}
        {renderMyBoards()}
        {renderSavedBoards()}

        {areAllEmpty && <div className='dashboard__empty'>
          <div
            className="button button--add"
            onClick={() => {
              openStore('qr_board', { modal: 'additionalProfiles' })
            }}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Kup tabliczkę QR na pomnik</h2>
            <p>Stwórz profil zmarłego, aby Twoi bliscy mogli:</p>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--heart"></i>
              </div>
              <div className="content">
                <h3>Wspomnieć zmarłego</h3>
                <p>Obejrzeć jego profil, zdjęcia oraz filmy</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--candle"></i>
              </div>
              <div className="content">
                <h3>Zapalić znicz</h3>
                <p>Dowiesz się kto odwiedził pomnik</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--book"></i>
              </div>
              <div className="content">
                <h3>Dodać wpis do księgi kondolencyjnej</h3>
                <p>Bliscy dodadzą wpis, zdjęcia oraz filmy</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--add-location"></i>
              </div>
              <div className="content">
                <h3>Zapiszą lokalizację</h3>
                <p>Zapiszą pomnik do listy odwiedzanych 1 listopada</p>
              </div>
            </div>
          </div>

          <div
            className="button button--normal"
            onClick={() => {
              navigate('/addprofile?onlyAdd=1')
            }}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Dodaj osobę do mapy pomników</h2>
            <p>Stwórz własną listę pomników<br></br>
              które odwiedzasz 1 Listopada.</p>
          </div>

          <div
            className="button button--normal"
            onClick={() => {
              if (isAuth) navigate(`/addprofile`, { state: { view: 'qrScanner', nextPage: 'form' } })
              else setModal({ type: 'login' })
            }}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Mam tabliczkę QR</h2>
            <p>Mozesz dodać osobę</p>
          </div>

          {/* <div
            className="button button--normal"
            onClick={() => {
              navigate('/addobituary')
            }}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Dodaj nekrolog</h2>
            <p>Będziesz mógł coś zrobić</p>
          </div> */}

        </div>}

        <div className="extraspace"></div>

        <BottomBar />
      </div>
    </>
  )
}

export default Dashboard